import { Fragment } from "react";
import { Nav, NavDropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";
import { NavArea, NavRuntime, NAV_GROUP_HEADERS, navItemsForArea } from "./navRegistry";

/* Generic leaf-menu renderer driven by navRegistry. Renders the visible items for an area,
 * inserting a divider between groups and a sub-section header when a group first appears.
 * Navigation items are links; `action` items call onAction (the leaf wires them to modals). */
export function NavMenu(props: {
  area: NavArea;
  runtime?: NavRuntime;
  onAction?: (action: string) => void;
  className?: string;
}) {
  const { t } = useTranslation();
  const location = useLocation();
  const items = navItemsForArea(props.area, props.runtime);
  const itemClass = (path?: string) => (path && location.pathname === path ? "bg-primary text-white" : "");

  let prevGroup: string | undefined;
  return (
    <Nav className={props.className ?? "flex-column hg-nav"}>
      {items.map((item) => {
        const newGroup = item.group !== prevGroup;
        const divider = newGroup && prevGroup !== undefined;
        const header = newGroup ? NAV_GROUP_HEADERS[item.group] : undefined;
        prevGroup = item.group;
        return (
          <Fragment key={item.id}>
            {divider && <NavDropdown.Divider />}
            {header && <NavDropdown.Header>{t(header)}</NavDropdown.Header>}
            {item.action ? (
              <NavDropdown.Item onClick={() => props.onAction?.(item.action!)}>{t(item.labelKey)}</NavDropdown.Item>
            ) : (
              <NavDropdown.Item
                as={Link}
                to={item.path!}
                target={item.external ? "_blank" : undefined}
                className={itemClass(item.path)}
              >
                {t(item.labelKey)}
              </NavDropdown.Item>
            )}
          </Fragment>
        );
      })}
    </Nav>
  );
}
